/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Step_1_DescInputs */

const en_mk_tb_step_1_desc = /** @type {(inputs: Mk_Tb_Step_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A claim reserves the task for one developer. Renew it while working or hand it off with context.`)
};

const id_mk_tb_step_1_desc = /** @type {(inputs: Mk_Tb_Step_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klaim mencadangkan tugas untuk satu developer. Perpanjang selama bekerja atau serahkan beserta konteksnya.`)
};

/**
* | output |
* | --- |
* | "A claim reserves the task for one developer. Renew it while working or hand it off with context." |
*
* @param {Mk_Tb_Step_1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_step_1_desc = /** @type {((inputs?: Mk_Tb_Step_1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Step_1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_step_1_desc(inputs)
	return en_mk_tb_step_1_desc(inputs)
});